import React from "react";
import { Radio, SimpleGrid, VStack } from "@chakra-ui/react";
import { RadioGroup } from "components";

interface ToothDiagnosisRadioProps {
  label: React.ReactNode;
  name: string;
  options: { value: string; label: React.ReactNode }[];
  columns?: number;
  rows?: number;
}

const ToothDiagnosisRadio: React.FC<ToothDiagnosisRadioProps> = ({
  label,
  name,
  options,
  columns = 1,
  rows
}) => (
  <VStack display="inline-flex">
    <RadioGroup label={label} name={name}>
      <SimpleGrid
        autoFlow={rows ? "column" : undefined}
        templateRows={rows ? `repeat(${rows}, auto)` : undefined}
        columns={columns}
        rowGap={2}
        columnGap={4}
      >
        {options.map(opt => (
          <Radio key={opt.value} value={opt.value}>
            {opt.label}
          </Radio>
        ))}
      </SimpleGrid>
    </RadioGroup>
  </VStack>
);

export default ToothDiagnosisRadio;
